import React, { Fragment } from 'react';
import CollectionSidebar from './CollectionSidebar.jsx';
import CollectionHeader from './CollectionHeader.jsx';
import CollectionProducts from './CollectionProducts.jsx';
import RelatedCollection from './RelatedCollection.jsx';

export default function CollectionContent(props) {
  const columnCount = props.metafields.settings && props.metafields.settings.columns || 3;
  let cName = `product-list row-of-${columnCount}`, sidebar = null;
  if (props.sidebar && props.sidebar.links && props.sidebar.links.length) {
    cName += ' product-list-withsidebar';
    sidebar = <CollectionSidebar contents={props.sidebar} collectionHandle={props.handle} breadcrumbs={props.breadcrumbs} />
  }
  return (
    <Fragment>
      <div className="content-area collection-content">
        {sidebar}
        <div className={cName}>
          <CollectionHeader metafields={props.metafields.header} title={props.title} description={props.description} image={props.image} mobile_image={props.mobile_image} />
          <CollectionProducts metafields={props.metafields.settings} products={props.products} groups={props.groups} blocks={props.blocks} texts={props.texts} collectionHandle={props.handle} swaps={props.swaps} columnCount={columnCount} groupOverrides={props.groupOverrides} />
        </div>
      </div>
      {props.related_collections.map((collection, i) => {
        return <RelatedCollection key={i} block={collection} className={cName} />
      })}
      {props.css.map((css, i) => {
        const stylesheet = `${css.css} @media(max-width: 719px){${css.mobile_css}} @media(min-width: 720px){${css.desktop_css}}`
        return <style key={i} dangerouslySetInnerHTML={{__html: stylesheet}} />
      })}
    </Fragment>
  )
}